import React, { useState, useEffect, useRef, useContext } from "react";
import tableImage from "../assets/images/table_1.png";
import {
  Card,
  Modal,
  Button,
  Table,
  Collapse,
  message,
  Popconfirm,
  Badge,
  Tooltip,
  Divider,
  Input,
} from "antd";
import { io } from "socket.io-client";
import axios from "axios";
import { DeleteOutlined, CheckOutlined } from "@ant-design/icons";
import "./BillList.css";
import PaymentPage from "../pages/PaymentPage";
import Receipt from "../components/Receipt";
import PreviewReceipt from "../components/PreviewReceipt";
import "./TableList.css";
import { getIsValidated } from "../utils/paymentData";
import { useValidation } from "../contexts/ValidationContext";
import CloseButton from "../components/CloseButton";
import { useSearchParams } from "react-router-dom";
import { setPaymentData, getPaymentData } from "../utils/paymentData";
import { invalid } from "moment";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useCurrency } from "../contexts/ValidationContext";
import { getCurrencySymbol } from "../utils/currencyHelper";
import config from "../config";
import { number } from "joi";
import { get, set, take } from "lodash";
import { should } from "chai";
import { ModalBlurContext } from "./DefaultLayout";
import AccessKeyModal from "./checkAccessKey";

const BillList = ({ table, tableOrders, taxes, services, settings }) => {
  // Always treat tableOrders as an array
  const safeTableOrders = Array.isArray(tableOrders) ? tableOrders : [];
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;

  // Always use the latest orders from props, not local state
  const orders = Array.isArray(tableOrders) ? tableOrders : [];
  const tableNumber = table.table_number;

  const [searchParams, setSearchParams] = useSearchParams();
  const [tableBillNumber, setTableBillNumber] = useState(
    searchParams.get("table")
  );
  const [takeAwayTable, setTakeAwayTable] = useState(false);
  const [serviceQuantity, setServiceQuantity] = useState({});
  const [servicesWithTotals, setServicesWithTotals] = useState([]);

  const { currency } = useCurrency();
  const symbol = getCurrencySymbol(currency);

  const { Meta } = Card;
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null); // New state for the selected order ID
  // const [taxes, setTaxes] = useState([
  //   {
  //     for_take_away: false,
  //     name: "Service Charge",
  //     rate: "10",
  //     __v: 0,
  //     _id: "68230d7ba366637ab8624cd9",
  //   },
  // ]);
  const [isPaymentValidated, setIsPaymentValidated] = useState(false); // handle show paid receipt button if Ok button is not selected
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const { isValidated, selectedTable } = useValidation();
  const [isPaymentButtonTapped, setIsPaymentButtonTapped] = useState(false);
  const [selectedOrders, setSelectedOrders] = useState(() => {
    const storedValue = localStorage.getItem("selectedOrders");
    return storedValue ? JSON.parse(storedValue) : [];
  });
  const [areAllCollapsed, setAreAllCollapsed] = useState(true);
  const [activeKeys, setActiveKeys] = useState([]);
  const [show, setShow] = useState(true);
  const [pax, setPax] = useState(() => Number(table.table_capacity) || 1);
  const [invoiceData, setInvoiceData] = useState(null);
  // const [settings, setSettings] = useState({ deliverDisableToggle: true });s

  // Add Here (Deposit)

  const [deposit, setDeposit] = useState("0.00");
  const [depositMethod, setDepositMethod] = useState("Paynow");
  const [depositNote, setDepositNote] = useState("");
  const [hasDeposit, setHasDeposit] = useState(false);
  const [depositKey, setDepositKey] = useState([]);
  const [selectedTaxToRemove, setSelectedTaxToRemove] = useState(null);

  const { incrementModal, decrementModal } = useContext(ModalBlurContext);

  useEffect(() => {
    setHasDeposit(table.hasDeposit);
    setDeposit(table.deposit.depositAmount);
    setDepositMethod(table.deposit.depositMethod);
    setDepositNote(table.deposit.depositNote);
  }, []);

  const { invoiceId: orderInvoiceId } = getPaymentData();
  const navigate = useNavigate();
  const receiptRef = useRef();
  useEffect(() => {
    localStorage.setItem("selectedOrders", JSON.stringify(selectedOrders));
  }, [selectedOrders]);
  const accessKeyModalRef = useRef();

  useEffect(() => {
    // Sync state with `searchParams` whenever the query changes
    setTableBillNumber(searchParams.get("table"));
  }, [searchParams]);

  const onChange = (key) => { };

  // useEffect(() => {
  //   if (orderInvoiceId) {
  //     console.log("Check Invoice:", orderInvoiceId);
  //     fetchInvoiceData(orderInvoiceId);
  //   }
  // }, [orderInvoiceId]);

  // const fetchInvoiceData = async (orderInvoiceId) => {
  //   try {
  //     const { data } = await axios.get(
  //       `${apiBaseUrl}/api/payments/${orderInvoiceId}`
  //     );
  //     setInvoiceData(data);
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       setShowReceiptModal(false);
  //     }
  //     setInvoiceData(null);
  //   } finally {
  //   }
  // };

  // useEffect(() => {
  //   // const socket = io("http://localhost:8080");
  //   let socketUrl;
  //   try {
  //       socketUrl = new URL(apiBaseUrl).host;
  //   } catch {
  //       socketUrl = apiBaseUrl;
  //   }

  //   const socket = io(socketUrl);

  //   socket.on("newOrder", (order) => {
  //     fetchTaxes();
  //     fetchServices();
  //     fetchTableOrders();
  //   });

  //   return () => socket.disconnect();
  // }, []);

  useEffect(() => {
    // Set up polling
    const intervalId = setInterval(() => {
      // fetchTaxes();
      // fetchServices();
      // fetchTableOrders();
    }, 7000); // 5000 milliseconds = 5 seconds

    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, [tableNumber]);

  useEffect(() => {
    if (tableBillNumber === table.table_number) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [tableBillNumber, table.table_number]);

  const handleCancel = () => {
    setOpen(false);
    // navigate('/bills');

    // window.history.replaceState(null, '', '/bills');
    setSearchParams({}, { replace: true });
    setTableBillNumber(null);
  };

  useEffect(() => {
    if (open) {
      incrementModal();
      return () => decrementModal();
    }
  }, [open, incrementModal, decrementModal]);

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };

  const handleOkClick = async () => {
    try {
      const ordersToUpdate = selectedOrders
        .filter((oid) => {
          const order = orders.find((order) => order.oid === oid); // Find the order by its ID
          if (!order) return false;

          if (settings.deliverDisableToggle === true) {
            return (
              order.order_progressstatus === "Receive" ||
              order.order_progressstatus === "Kitchen"
            );
          } else {
            return order.order_progressstatus === "Receive";
          }
        })
        .map((oid) => ({
          orderId: oid,
          order_progressstatus: "Paid",
          pax: pax,
        }));

      // Iterate over each order and update its status
      for (const order of ordersToUpdate) {
        const response = await axios.put(
          `${apiBaseUrl}/api/orders/edit-order`,
          {
            orders: [order], // Send one order at a time
          }
        );

        if (response.status !== 200) {
          console.error(`Failed to update order ID ${order.orderId}`);
        }
      }

      Swal.fire({
        title: "Success",
        text: "Orders updated successfully",
        toast: true,
        icon: "success",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to update orders",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  // const fetchTaxes = async () => {
  //   try {
  //     const response = await axios.get(`${apiBaseUrl}/api/taxes/get-taxes`);
  //     setTaxes(response.data);
  //   } catch (error) {
  //     console.error("Error fetching taxes:", error);
  //     message.error("Failed to fetch taxes.");
  //   }
  // };

  // const fetchServices = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${apiBaseUrl}/api/services/get-services`
  //     );
  //     setServices(response.data);
  //   } catch (error) {
  //     console.error("Error fetching services:", error);
  //     message.error("Failed to fetch services.");
  //   }
  // };

  const { Panel } = Collapse;

  const calculateTotalWithoutTaxes = (order) => {
    return order.order_items
      .reduce((acc, curr) => {
        if (curr.product.category === "Combo") {
          // For combo items: only add prices for custom options (from empty groups)
          // Standard menu items (from named groups) are included in combo price
          const customOptionsTotal = curr.product.addOns.reduce((addOnsAcc, addOn) => {
            // Only add price if it's a custom option (has id from timestamp, not _id from database)
            // Standard menu items (with _id) have their pricing disabled
            const isCustomOption = addOn.isCategoryItem ? false : (addOn.id && !addOn._id);
            if (isCustomOption) {
              const addOnPriceFixed = parseFloat(
                parseFloat(addOn.price).toFixed(2)
              );
              return addOnsAcc + addOnPriceFixed;
            }
            return addOnsAcc;
          }, 0);

          const customOptionsTotalFixed = parseFloat(customOptionsTotal).toFixed(2);

          // Calculate the total price for this combo item: base price + custom options only
          const totalItemPrice =
            (parseFloat(customOptionsTotalFixed) + parseFloat(curr.product.price)) *
            curr.quantity;

          return acc + totalItemPrice;
        } else {
          // For regular items, add all add-on prices
          const addOnsTotal = curr.product.addOns.reduce((addOnsAcc, addOn) => {
            // Apply toFixed(2) to each add-on price and convert back to number
            const addOnPriceFixed = parseFloat(
              parseFloat(addOn.price).toFixed(2)
            );
            return addOnsAcc + addOnPriceFixed;
          }, 0);

          const addOnsTotalFixed = parseFloat(addOnsTotal).toFixed(2);

          // Calculate the total price for this item, including the add-ons and base price
          const totalItemPrice =
            (parseFloat(addOnsTotalFixed) + parseFloat(curr.product.price)) *
            curr.quantity;

          return acc + totalItemPrice;
        }
      }, 0)
      .toFixed(2);
  };

  const getTotalWithoutTaxes = () => {
    const totalOrders = orders
      .filter((order) =>
      // selectedOrders.includes(order.oid) &&
      // order.order_progressstatus === "Receive"
      {
        if (!selectedOrders.includes(order.oid)) return false;

        if (settings.deliverDisableToggle === true) {
          return (
            order.order_progressstatus === "Receive" ||
            order.order_progressstatus === "Kitchen"
          );
        } else {
          return order.order_progressstatus === "Receive";
        }
      }
      )
      .reduce(
        (total, order) => total + parseFloat(calculateTotalWithoutTaxes(order)),
        0
      );
    return totalOrders.toFixed(2);

    // if (table.is_take_away_table === false) {
    //   const totalDineInServiceCharge = servicesWithTotals
    //     .filter((s) => s.for_take_away === false)
    //     .reduce((total, s) => total + s.totalPrice, 0);

    //   const total = totalOrders + totalDineInServiceCharge;

    //   return total.toFixed(2);
    // } else {
    //   const totalTakeAwayServiceCharge = servicesWithTotals
    //     .filter((s) => s.for_take_away === true)
    //     .reduce((total, s) => total + s.totalPrice, 0);
    //   const total = totalOrders + totalTakeAwayServiceCharge;
    //   return total.toFixed(2);
    // }
  };

  const calculateTotalCanDiscount = (order) => {
    return order.order_items
      .filter(
        (item) =>
          item.product.discountAble === true ||
          item.product.discountAble !== false
      )
      .reduce((acc, curr) => {
        const addOnsTotal = curr.product.addOns.reduce((addOnsAcc, addOn) => {
          const addOnPriceFixed = parseFloat(
            parseFloat(addOn.price).toFixed(2)
          );
          return addOnsAcc + addOnPriceFixed;
        }, 0);

        const addOnsTotalFixed = parseFloat(addOnsTotal).toFixed(2);

        const totalItemPrice =
          (parseFloat(addOnsTotalFixed) + parseFloat(curr.product.price)) *
          curr.quantity;

        return acc + totalItemPrice;
      }, 0)
      .toFixed(2);
  };

  const getTotalCanDiscount = () => {
    return orders
      .filter((order) =>
      // selectedOrders.includes(order.oid) &&
      // order.order_progressstatus === "Receive"
      {
        if (!selectedOrders.includes(order.oid)) return false;

        if (settings.deliverDisableToggle === true) {
          return (
            order.order_progressstatus === "Receive" ||
            order.order_progressstatus === "Kitchen"
          );
        } else {
          return order.order_progressstatus === "Receive";
        }
      }
      )
      .reduce(
        (total, order) => total + parseFloat(calculateTotalCanDiscount(order)),
        0
      )
      .toFixed(2);
  };

  const getTotalWithTaxes = () => {
    const filteredOrders = orders.filter((order) => {
      const isSelected = selectedOrders.includes(order.oid);
      // const isReceived = order.order_progressstatus === "Receive";
      const isReceived =
        settings.deliverDisableToggle === true
          ? order.order_progressstatus === "Receive" ||
          order.order_progressstatus === "Kitchen"
          : order.order_progressstatus === "Receive";

      return isSelected && isReceived; // Only selected orders with "Receive" status
    });

    const totalWithoutTax = filteredOrders
      .reduce((acc, order) => {
        // For each order, calculate the total price of its items
        const orderTotal = order.order_items.reduce((orderAcc, curr) => {
          // Calculate the total price of all add-ons for the current product
          const addOnsTotal = curr.product.addOns.reduce((addOnsAcc, addOn) => {
            // Apply toFixed(2) to each add-on price and convert back to number
            const addOnPriceFixed = parseFloat(
              parseFloat(addOn.price).toFixed(2)
            );
            return addOnsAcc + addOnPriceFixed;
          }, 0);

          const addOnsTotalFixed = parseFloat(addOnsTotal.toFixed(2));

          // Calculate the total price for this item, including the add-ons and base price
          const totalItemPrice =
            (addOnsTotalFixed + parseFloat(curr.product.price)) * curr.quantity;

          return orderAcc + totalItemPrice;
        }, 0);

        return acc + orderTotal;
      }, 0)
      .toFixed(2);

    // const totalServiceCharge = servicesWithTotals.reduce(
    //   (total, s) => total + s.totalPrice,
    //   0
    // );

    // const totalWithServices =
    //   Number(totalWithoutTax) + Number(totalServiceCharge);

    // Calculate total tax
    const totalTax = taxes.reduce((acc, tax) => {
      const shouldApplyTax =
        !takeAwayTable || (takeAwayTable && tax.for_take_away);

      const individualTax = shouldApplyTax
        ? parseFloat((totalWithoutTax * (tax.rate / 100)).toFixed(2))
        : 0;
      return acc + individualTax;
    }, 0);

    // Calculate total with tax
    const totalWithTax = (parseFloat(totalWithoutTax) + totalTax).toFixed(2);
    return totalWithTax;
  };

  const getTotalWithServices = () => {
    const totalWithTaxes = getTotalWithTaxes();
    const totalServiceCharge = servicesWithTotals.reduce(
      (total, s) => total + s.totalPrice,
      0
    );
    return (Number(totalWithTaxes) + Number(totalServiceCharge)).toFixed(2);
  };

  // const getTotalTaxes = () => {
  //   // Filter orders based on selection and status
  //   const filteredOrders = orders.filter((order) => {
  //     const isSelected = selectedOrders.includes(order.oid);
  //     // const isReceived = order.order_progressstatus === "Receive";
  //     const isReceived =
  //       settings.deliverDisableToggle === true
  //         ? order.order_progressstatus === "Receive" ||
  //           order.order_progressstatus === "Kitchen"
  //         : order.order_progressstatus === "Receive";

  //     return isSelected && isReceived; // Only selected orders with "Receive" status
  //   });

  //   const totalWithoutTax = filteredOrders
  //     .reduce((acc, order) => {
  //       // For each order, calculate the total price of its items
  //       const orderTotal = order.order_items.reduce((orderAcc, curr) => {
  //         // Calculate the total price of all add-ons for the current product
  //         const addOnsTotal = curr.product.addOns.reduce((addOnsAcc, addOn) => {
  //           // Apply toFixed(2) to each add-on price and convert back to number
  //           const addOnPriceFixed = parseFloat(
  //             parseFloat(addOn.price).toFixed(2)
  //           );
  //           return addOnsAcc + addOnPriceFixed;
  //         }, 0);

  //         const addOnsTotalFixed = parseFloat(addOnsTotal.toFixed(2));

  //         // Calculate the total price for this item, including the add-ons and base price
  //         const totalItemPrice =
  //           (addOnsTotalFixed + parseFloat(curr.product.price)) * curr.quantity;

  //         return orderAcc + totalItemPrice;
  //       }, 0);

  //       return acc + orderTotal;
  //     }, 0)
  //     .toFixed(2);

  //   // const totalServiceCharge = servicesWithTotals.reduce(
  //   //   (total, s) => total + s.totalPrice,
  //   //   0
  //   // );

  //   // const totalWithServices =
  //   //   Number(totalWithoutTax) + Number(totalServiceCharge);

  //   // Calculate total tax
  //   const totalTax = taxes.reduce((acc, tax) => {
  //     const shouldApplyTax =
  //       !takeAwayTable || (takeAwayTable && tax.for_take_away);

  //     const individualTax = shouldApplyTax
  //       ? parseFloat((totalWithoutTax * (tax.rate / 100)).toFixed(2))
  //       : 0;
  //     return acc + individualTax;
  //   }, 0);

  //   return totalTax.toFixed(2);
  // };

  useEffect(() => {
    if (table.is_take_away_table === true) {
      setTakeAwayTable(true);
      setPax(1);
    } else {
      setTakeAwayTable(false);
    }
  }, [table.is_take_away_table]);

  //user cannot key in 0 or negative number for pax number
  const handlePaxChange = (e) => {
    let value = Number(e.target.value);
    setPax(value);
  };

  const handlePaymentValidation = async () => {
    try {
      // You can remove the API call from here since it's already done in submitPayment
      // Handle the response from submitPayment instead
      await handleOkClick(); // This function already updates order status

      setShowPaymentModal(false); // Close payment modal
      handleClosePaymentModal();
      setShowReceiptModal(true); // Show receipt modal
      setIsPaymentButtonTapped(false);
      setIsPaymentValidated(true);
    } catch (error) {
      console.error("Error during payment validation:", error);
      alert("An error occurred while processing the payment.");
    }
  };

  const printReceipt = () => {
    // Print receipt logic or open receipt modal
    setShowReceiptModal(true);
    // After showing the receipt, you might want to print it or handle it accordingly
  };

  const handleCheckboxChange = (event, orderId) => {
    const storedValue =
      JSON.parse(localStorage.getItem("selectedOrders")) || [];
    let updatedOrders;

    if (event.target.checked) {
      updatedOrders = [...new Set([...storedValue, orderId])];
    } else {
      updatedOrders = storedValue.filter((id) => id !== orderId);
    }

    setSelectedOrders(updatedOrders);
  };

  const showModal = () => {
    setOpen(true);
    const currentPath = window.location.pathname;
    const newUrl = `${currentPath}?table=${table.table_number}`;
    window.history.replaceState({}, "", newUrl);
  };

  const getTotalItems = () => {
    return orders
      .reduce((total, order) => {
        if (Array.isArray(order.order_items)) {
          return (
            total +
            order.order_items.reduce((acc, curr) => {
              return acc + (curr.quantity || 0); // Default to 0 if undefined
            }, 0)
          );
        }
        return total; // If order.result is not an array, return the current total
      }, 0)
      .toFixed(0);
  };
  const totalItems = getTotalItems();

  const calculateOrderCounts = (orders) => {
    let countOrder = 0;
    let countKitchen = 0;
    let countDelivered = 0;

    orders.forEach((order) => {
      if (order.order_progressstatus === "") {
        countOrder += 1;
      }
      if (order.order_progressstatus === "Kitchen") {
        countKitchen += 1;
      }
      if (order.order_progressstatus === "Receive") {
        countDelivered += 1;
      }
    });

    return { countOrder, countKitchen, countDelivered };
  };

  // Assuming `orders` is an array of order objects
  const { countOrder, countKitchen, countDelivered } =
    calculateOrderCounts(orders);

  const getBadgeStyle = (count, color) => {
    return {
      backgroundColor: count > 0 ? color : "#d9d9d9", // Grey color for count 0
    };
  };

  const handleCollapseToggle = () => {
    setAreAllCollapsed((prev) => !prev);

    if (areAllCollapsed) {
      // If currently collapsed, expand all
      setActiveKeys(orders.map((order) => order.oid));
    } else {
      // If currently expanded, collapse all
      setActiveKeys([]);
    }
  };

  const handlePanelChange = (keys) => {
    setActiveKeys(keys); // Update active keys when individual panels are toggled
  };

  // --- Fix handleSelectAll and handleDeselectAll ---
  const handleSelectAll = () => {
    // Use tableOrders as an array (already passed as array prop)
    const tableOrdersForCurrentTable = Array.isArray(tableOrders)
      ? tableOrders
      : [];
    const storedSelectedOrders =
      JSON.parse(localStorage.getItem("selectedOrders")) || [];
    const allOrderIds = tableOrdersForCurrentTable.map((order) => order.oid);
    const updatedSelectedOrders = [
      ...new Set([...storedSelectedOrders, ...allOrderIds]),
    ];
    setSelectedOrders(updatedSelectedOrders);
    localStorage.setItem(
      "selectedOrders",
      JSON.stringify(updatedSelectedOrders)
    );
    const openKeys = [
      ...new Set([
        ...(Array.isArray(activeKeys) ? activeKeys : []),
        ...allOrderIds,
      ]),
    ];
    setActiveKeys(openKeys);
  };

  const handleDeselectAll = () => {
    const storedSelectedOrders =
      JSON.parse(localStorage.getItem("selectedOrders")) || [];
    const tableOrdersForCurrentTable = Array.isArray(tableOrders)
      ? tableOrders
      : [];
    const allOrderIds = tableOrdersForCurrentTable.map((order) => order.oid);
    const updatedSelectedOrders = storedSelectedOrders.filter(
      (orderId) => !allOrderIds.includes(orderId)
    );
    setSelectedOrders(updatedSelectedOrders);
    localStorage.setItem(
      "selectedOrders",
      JSON.stringify(updatedSelectedOrders)
    );
    const remainingKeys = (activeKeys || []).filter(
      (key) => !allOrderIds.includes(key)
    );
    setActiveKeys(remainingKeys);
  };

  // --- Update Card color/text logic to use tableOrders array ---
  const isBusy =
    table.table_status &&
    tableOrders.some(
      (order) => order.order_status && order.order_voidstatus !== true
    );

  useEffect(() => {
    const updated = services.map((service) => {
      let quantity = 0;
      quantity = serviceQuantity[service._id] ?? 0;

      let totalPrice = 0;
      totalPrice = quantity * service.price;

      return { ...service, quantity, totalPrice };
    });

    setServicesWithTotals(updated);
  }, [services, serviceQuantity, table.is_take_away_table]);

  // Stub for handleVoidDeposit
  const handleVoidDeposit = async () => {
    const result = await Swal.fire({
      title: "Warning",
      text: "Are you sure you want to void this deposit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });

    if (result.isConfirmed) {
      voidDeposit();
    }
  };

  const voidDeposit = async () => {
    try {
      let userId;
      if (settings.isAccessKeyNeeded) {

        const operator = await accessKeyModalRef.current?.show();
        if (!operator) {
          return;
        } else {
          userId = operator?.user?.userId;
        }
      } else {
        userId = localStorage.getItem("userId");
      }

      const payload = {
        tableId: table._id,
        hasDeposit: false,
        deposit: {
          depositAmount: "0.00",
          depositMethod: "Paynow",
          depositNote: "",
        },
      };

      const response = await axios.put(
        `${apiBaseUrl}/api/tables/edit-table`,
        payload
      );

      if (response.status === 200) {
        setHasDeposit(false);
        setDeposit("0.00");
        setDepositMethod("Paynow");
        setDepositNote("");
      } else {
        console.error("Failed to update table:", response.data);
      }
    } catch (error) {
      console.error("Error updating table:", error);
    }
  };

  // Calculate rounding for totals section
  const grandTotal = Math.round(getTotalWithServices() * 20) / 20;
  const rounding = (grandTotal - getTotalWithServices()).toFixed(2);

  // Helper to check if any modal is open
  const anyModalOpen = open || showReceiptModal || showPaymentModal;

  useEffect(() => {
    if (open) {
      incrementModal();
      return () => decrementModal();
    }
  }, [open, incrementModal, decrementModal]);

  useEffect(() => {
    if (showReceiptModal) {
      incrementModal();
      return () => decrementModal();
    }
  }, [showReceiptModal, incrementModal, decrementModal]);

  useEffect(() => {
    if (showPaymentModal) {
      incrementModal();
      return () => decrementModal();
    }
  }, [showPaymentModal, incrementModal, decrementModal]);

  const footerButtonDisabledStyle = {
    backgroundColor: "#f3f4f6", // light gray
    color: "#bdbdbd",           // muted text
    border: "2px solid #e5e7eb",
    cursor: "not-allowed"
  };

  // Calculate taxes for preview receipt
  const calculatePreviewTaxes = (taxesData, totalAfterDiscount) => {
    if (!taxesData || taxesData.length === 0) return [];
    return taxesData.map((tax) => {
      const shouldApplyTax = !takeAwayTable || tax.for_take_away;
      const removedTax = selectedTaxToRemove === tax._id;
      let taxRateCalculate = tax.rate;
      if (removedTax) {
        taxRateCalculate = 0;
      } else {
        tax.rate = taxRateCalculate;
      }
      const taxAmount = shouldApplyTax
        ? parseFloat(totalAfterDiscount * (tax.rate / 100)).toFixed(2)
        : "0.00";
      return {
        taxName: tax.name,
        taxRate: `${tax.rate}%`,
        taxAmount,
        taxValidForTakeAway: tax.for_take_away,
      };
    });
  };

  const handleOpenPaymentModal = () => {
    setShowPaymentModal(true);
    // Emit previewReceipt event to customer display
    const userId = localStorage.getItem("userId");
    let socketUrl;
    try {
      socketUrl = config.REACT_APP_API_BASE_URL;
    } catch {
      socketUrl = config.REACT_APP_API_BASE_URL;
    }
    const socket = io(socketUrl, { query: { userId } });
    // Prepare preview data (similar to PaymentPage.js)
    const formattedServices = servicesWithTotals.map((s) => ({ ...s, totalPrice: s.totalPrice?.toFixed ? s.totalPrice.toFixed(2) : s.totalPrice }));
    const totalAfterDiscount = getTotalWithoutTaxes();
    const previewTaxes = calculatePreviewTaxes(taxes, totalAfterDiscount);
    const grandTotal = Math.round(getTotalWithServices() * 20) / 20;
    const rounding = (grandTotal - getTotalWithServices()).toFixed(2);
    const previewData = {
      totalWithoutTaxes: getTotalWithoutTaxes(),
      discount: 0,
      totalAfterDiscount,
      taxes: previewTaxes,
      totalTaxes: previewTaxes.reduce((acc, tax) => acc + parseFloat(tax.taxAmount), 0),
      totalWithTaxes: getTotalWithTaxes(),
      totalWithServices: getTotalWithServices(),
      rounding,
      roundedTotalWithServices: grandTotal.toFixed(2),
      deposit,
      payableAmount: getTotalWithServices(),
      depositMethod,
      cashAmount: 0,
      balance: 0,
      paymentMethod: "Cash",
      transactionId: "",
      newestInvoiceId: null,
      remarks: null,
      currentCashierName: null,
      isPreview: true,
      orderDetails: safeTableOrders.filter((order) => selectedOrders.includes(order.oid)),
    };
    socket.emit("previewReceipt", {
      userId,
      paymentData: previewData,
      tableNumber: table.table_number,
      pax,
      services: formattedServices,
      takeAwayTable,
    });
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
    // Emit closePreviewReceipt event to customer display
    const userId = localStorage.getItem("userId");
    let socketUrl;
    try {
      socketUrl = config.REACT_APP_API_BASE_URL;
    } catch {
      socketUrl = config.REACT_APP_API_BASE_URL;
    }
    const socket = io(socketUrl, { query: { userId } });
    socket.emit("closePreviewReceipt", { userId });
  };

  return (
    <div className="table-list-page">
      <div className="card-size">
        <Card
          hoverable
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "130px",
            width: "120px",
            alignItems: "center",
            textAlign: "center",
            marginBottom: "14px",
            borderRadius: "12px",
            backgroundColor: table.table_status
              ? isBusy
                ? "#fef2f2"
                : "#f0fdf4"
              : "#f8f9fa",
            boxShadow: table.table_status
              ? "0 4px 16px rgba(0, 0, 0, 0.08)"
              : "0 2px 8px rgba(0, 0, 0, 0.04)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            position: "relative",
            border: table.table_status
              ? isBusy
                ? "2px solid #fecaca"
                : "2px solid #7dee7d"
              : "2px solid #e9ecef",
            cursor: table.table_status ? "pointer" : "not-allowed",
            overflow: "hidden",
          }}
          onClick={
            table.table_status ? () => showModal(table.table_number) : null
          }
          onMouseEnter={(e) => {
            if (table.table_status) {
              e.currentTarget.style.boxShadow =
                "0 8px 20px rgba(0, 0, 0, 0.12)";
            }
          }}
          onMouseLeave={(e) => {
            if (table.table_status) {
              e.currentTarget.style.boxShadow =
                "0 4px 16px rgba(0, 0, 0, 0.08)";
            }
          }}
        >
          {/* Status Indicator Bar */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              backgroundColor: table.table_status
                ? isBusy
                  ? "#ef4444"
                  : "#7dee7d"
                : "#9ca3af",
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {/* Badge Row */}
            <div className="badge-row" style={{ marginBottom: "2px" }}>
              <span
                className={`badge-dot-pos ${countOrder > 0 ? "order" : "gray"}`}
              >
                {countOrder}
              </span>
              <span
                className={`badge-dot-pos ${countKitchen > 0 ? "kitchen" : "gray"
                  }`}
              >
                {countKitchen}
              </span>
              <span
                className={`badge-dot-pos ${countDelivered > 0 ? "delivered" : "gray"
                  }`}
              >
                {countDelivered}
              </span>
            </div>
            {/* Table Number */}
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "rgba(0, 0, 0, 0.6)",
                  marginBottom: "2px",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              ></div>
              <div
                style={{
                  fontSize:
                    table.table_number.length > 16
                      ? "16px"
                      : table.table_number.length > 10
                        ? "20px"
                        : "28px",
                  fontWeight: "500",
                  color: "rgba(0, 0, 0, 0.7)",
                  lineHeight: "1.1",
                  textAlign: "center",
                }}
              >
                {table.table_number}
              </div>
            </div>
            {/* Status Badge */}
            <div
              className={`status-badge-pos ${table.table_status && isBusy ? "busy" : "available"
                }`}
              style={{
                marginTop: "10px",
                fontSize: "12px",
                padding: "3px 10px",
              }}
            >
              <span className="status-dot" />
              {table.table_status && isBusy ? "BUSY" : "AVAILABLE"}
            </div>
          </div>
        </Card>
      </div>

      <Modal
        open={open}
        title={
          <div>
            <CloseButton onClick={handleCancel} />
            <div
              className="tablePadding"
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "#1f2937",
                marginBottom: "8px",
                textAlign: "center",
              }}
            >
              {`Table ${table.table_number}`}
            </div>
            <div
              className="showButtonOnTop"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              {/* Toggle Select All/Deselect All Button */}
              <Button
                type="default"
                style={
                  safeTableOrders.filter(order => {
                    if (
                      order.order_progressstatus === "Paid" ||
                      order.order_progressstatus === "Void"
                    ) {
                      return false;
                    }
                    if (settings.deliverDisableToggle === true) {
                      return (
                        order.order_progressstatus === "Receive" ||
                        order.order_progressstatus === "Kitchen"
                      );
                    } else {
                      return order.order_progressstatus === "Receive";
                    }
                  }).length === 0
                    ? { borderRadius: "8px", fontWeight: "700", height: "36px", padding: "0 16px", border: "2px solid #e5e7eb", backgroundColor: "#ffffff", color: "#374151", ...footerButtonDisabledStyle }
                    : { borderRadius: "8px", fontWeight: "700", height: "36px", padding: "0 16px", border: "2px solid #e5e7eb", backgroundColor: "#ffffff", color: "#374151" }
                }
                onClick={() => {
                  const eligibleOrders = safeTableOrders
                    .filter(order => {
                      if (
                        order.order_progressstatus === "Paid" ||
                        order.order_progressstatus === "Void"
                      ) {
                        return false;
                      }
                      if (settings.deliverDisableToggle === true) {
                        return (
                          order.order_progressstatus === "Receive" ||
                          order.order_progressstatus === "Kitchen"
                        );
                      } else {
                        return order.order_progressstatus === "Receive";
                      }
                    })
                    .map(order => order.oid);

                  const allSelected = eligibleOrders.length > 0 && eligibleOrders.every(oid => selectedOrders.includes(oid));

                  if (allSelected) {
                    // Deselect all
                    const updatedSelectedOrders = selectedOrders.filter(oid => !eligibleOrders.includes(oid));
                    setSelectedOrders(updatedSelectedOrders);
                    localStorage.setItem("selectedOrders", JSON.stringify(updatedSelectedOrders));
                    setActiveKeys(activeKeys.filter(key => !eligibleOrders.includes(key)));
                  } else {
                    // Select all
                    const updatedSelectedOrders = Array.from(new Set([...selectedOrders, ...eligibleOrders]));
                    setSelectedOrders(updatedSelectedOrders);
                    localStorage.setItem("selectedOrders", JSON.stringify(updatedSelectedOrders));
                    setActiveKeys(Array.from(new Set([...activeKeys, ...eligibleOrders])));
                  }
                }}
                disabled={
                  safeTableOrders.filter(order => {
                    if (
                      order.order_progressstatus === "Paid" ||
                      order.order_progressstatus === "Void"
                    ) {
                      return false;
                    }
                    if (settings.deliverDisableToggle === true) {
                      return (
                        order.order_progressstatus === "Receive" ||
                        order.order_progressstatus === "Kitchen"
                      );
                    } else {
                      return order.order_progressstatus === "Receive";
                    }
                  }).length === 0
                }
              >
                {(() => {
                  const eligibleOrders = safeTableOrders
                    .filter(order => {
                      if (
                        order.order_progressstatus === "Paid" ||
                        order.order_progressstatus === "Void"
                      ) {
                        return false;
                      }
                      if (settings.deliverDisableToggle === true) {
                        return (
                          order.order_progressstatus === "Receive" ||
                          order.order_progressstatus === "Kitchen"
                        );
                      } else {
                        return order.order_progressstatus === "Receive";
                      }
                    })
                    .map(order => order.oid);
                  const allSelected = eligibleOrders.length > 0 && eligibleOrders.every(oid => selectedOrders.includes(oid));
                  return allSelected ? "Deselect All" : "Select All";
                })()}
              </Button>
              <Button
                type="default"
                style={
                  !safeTableOrders.some((order) => {
                    if (settings.deliverDisableToggle === true) {
                      return (
                        order.order_progressstatus === "Receive" ||
                        order.order_progressstatus === "Kitchen"
                      );
                    } else {
                      return order.order_progressstatus === "Receive";
                    }
                  })
                    ? { borderRadius: "8px", fontWeight: "700", height: "36px", padding: "0 16px", border: "2px solid #e5e7eb", backgroundColor: "#ffffff", color: "#374151", ...footerButtonDisabledStyle }
                    : { borderRadius: "8px", fontWeight: "700", height: "36px", padding: "0 16px", border: "2px solid #e5e7eb", backgroundColor: "#ffffff", color: "#374151" }
                }
                onClick={handleCollapseToggle}
                disabled={
                  !safeTableOrders.some((order) => {
                    if (settings.deliverDisableToggle === true) {
                      return (
                        order.order_progressstatus === "Receive" ||
                        order.order_progressstatus === "Kitchen"
                      );
                    } else {
                      return order.order_progressstatus === "Receive";
                    }
                  })
                }
              >
                {areAllCollapsed ? "Expand All" : "Collapse All"}
              </Button>
              <div
                className="BadgeCountDesign"
                style={{
                  display: "flex",
                  gap: "8px",
                  marginLeft: "auto",
                  borderRadius: "12px",
                }}
              >
                <Tooltip title="Delivered">
                  <Badge
                    className="BadgePerCountDesign"
                    count={show ? countDelivered : 0}
                    showZero
                    style={{
                      ...getBadgeStyle(show ? countDelivered : 0, "#10b981"),
                      fontSize: "12px",
                      fontWeight: "700",
                      borderRadius: "10px",
                      minWidth: "24px",
                      height: "24px",
                      lineHeight: "24px",
                      boxShadow: "0 2px 4px rgba(16, 185, 129, 0.3)",
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        }
        onOk={handleOk}
        onCancel={handleCancel}
        className="fixed-footer"
        width={1000}
        footer={[
          <div
            key="footer-content"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p style={{ fontSize: "1.2em" }}>
              Grand Total:
              <strong style={{ fontSize: "1.8em" }}>
                {" "}
                {symbol} {grandTotal.toFixed(2)}
              </strong>
            </p>

            <Button
              key="payment"
              type={
                !(
                  Array.isArray(tableOrders) &&
                  tableOrders.some((order) =>
                    selectedOrders.includes(order.oid)
                  )
                ) ||
                  !(
                    Array.isArray(tableOrders) &&
                    tableOrders.some((order) => {
                      if (settings.deliverDisableToggle === true) {
                        return (
                          order.order_progressstatus === "Receive" ||
                          order.order_progressstatus === "Kitchen"
                        );
                      } else {
                        return order.order_progressstatus === "Receive";
                      }
                    })
                  )
                  ? "default"
                  : "primary"
              }
              style={
                !(
                  Array.isArray(tableOrders) &&
                  tableOrders.some((order) =>
                    selectedOrders.includes(order.oid)
                  )
                ) ||
                  !(
                    Array.isArray(tableOrders) &&
                    tableOrders.some((order) => {
                      if (settings.deliverDisableToggle === true) {
                        return (
                          order.order_progressstatus === "Receive" ||
                          order.order_progressstatus === "Kitchen"
                        );
                      } else {
                        return order.order_progressstatus === "Receive";
                      }
                    })
                  )
                  ? { borderRadius: "8px", fontWeight: "700", height: "45px", padding: "0 20px", fontSize: "18px", border: "2px solid #e5e7eb", backgroundColor: "#ffffff", color: "#374151", transition: "all 0.2s ease", ...footerButtonDisabledStyle }
                  : { borderRadius: "8px", fontWeight: "700", height: "45px", padding: "0 20px", fontSize: "18px", border: "2px solid #e5e7eb", backgroundColor: "#ffffff", color: "#374151", transition: "all 0.2s ease" }
              }
              onClick={() => {
                setIsPaymentButtonTapped(true);
                handleOpenPaymentModal();
              }}
              disabled={
                !(
                  Array.isArray(tableOrders) &&
                  tableOrders.some((order) =>
                    selectedOrders.includes(order.oid)
                  )
                ) ||
                !(
                  Array.isArray(tableOrders) &&
                  tableOrders.some((order) => {
                    if (settings.deliverDisableToggle === true) {
                      return (
                        order.order_progressstatus === "Receive" ||
                        order.order_progressstatus === "Kitchen"
                      );
                    } else {
                      return order.order_progressstatus === "Receive";
                    }
                  })
                )
              }
            >
              Payment
            </Button>
          </div>,
        ]}
      >
        {/* Add Here (Deposit UI) */}
        {hasDeposit && (
          <Collapse
            style={{ marginBottom: "20px" }}
            expandIcon={() => null}
            activeKey={depositKey}
            onChange={(keys) => {
              if (depositNote !== "") {
                setDepositKey(keys);
              }
            }}
          >
            <span>
              <Badge.Ribbon color="gray" />
            </span>
            <Panel
              key="depositPanel"
              className="panelDesign"
              style={{
                backgroundColor: "#f8fafc",
                borderRadius: "12px",
                marginBottom: "16px",
                border: "1px solid #e5e7eb",
                overflow: "hidden",
              }}
              header={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 0",
                    width: "100%",
                  }}
                >
                  <strong
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#1f2937",
                      display: "block",
                      marginBottom: "4px",
                    }}
                  >
                    Deposit {symbol}
                    {deposit} by {[depositMethod]}
                  </strong>
                  <div
                    style={{
                      marginLeft: "auto",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <Tooltip title="Void Deposit">
                      <DeleteOutlined
                        style={{
                          color: "#ef4444",
                          fontSize: "20px",
                          cursor: "pointer",
                          padding: "6px",
                          borderRadius: "6px",
                          transition: "all 0.2s ease"
                        }}
                        onMouseOver={e => {
                          e.target.style.backgroundColor = "#fef2f2";
                          e.target.style.color = "#dc2626";
                        }}
                        onMouseOut={e => {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "#ef4444";
                        }}
                        onClick={handleVoidDeposit}
                      />
                    </Tooltip>
                    <Badge className="badgeStyle" status="success" />
                  </div>
                </div>
              }
            >
              {depositNote && (
                <p
                  style={{
                    padding: "8px 0",
                    fontSize: "14px",
                    color: "#374151",
                  }}
                >
                  <strong>Note:</strong> {depositNote}
                </p>
              )}
            </Panel>
          </Collapse>
        )}

        <Collapse activeKey={activeKeys} onChange={handlePanelChange}>
          {safeTableOrders
            .filter((order) => {
              if (
                order.order_progressstatus === "Paid" ||
                order.order_progressstatus === "Void"
              ) {
                return false;
              }
              if (settings.deliverDisableToggle === true) {
                return (
                  order.order_progressstatus === "Receive" ||
                  order.order_progressstatus === "Kitchen"
                );
              } else {
                return order.order_progressstatus === "Receive";
              }
            })
            .map((order) => (
              <Panel
                key={order.oid}
                className="panelDesign"
                style={{
                  backgroundColor: "#f8fafc",
                  borderRadius: "12px",
                  marginBottom: "16px",
                  border: "1px solid #e5e7eb",
                }}
                header={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "12px 0",
                      width: "100%",
                      gap: "16px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedOrders.includes(order.oid)}
                      onChange={(e) => {
                        handleCheckboxChange(e, order.oid);
                        if (e.target.checked) {
                          const keys = Array.isArray(activeKeys)
                            ? [...new Set([...activeKeys, order.oid])]
                            : [order.oid];
                          handlePanelChange(keys);
                        } else {
                          const keys = Array.isArray(activeKeys)
                            ? activeKeys.filter((key) => key !== order.oid)
                            : [];
                          handlePanelChange(keys);
                        }
                      }}
                      style={{
                        marginRight: "16px",
                        transform: "scale(1.2)",
                        accentColor: "#3b82f6",
                      }}
                    />
                    <div style={{ flex: 1 }}>
                      <strong
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#1f2937",
                          display: "block",
                          marginBottom: "4px",
                        }}
                      >
                        Order #{order.oid}
                      </strong>
                      {order.order_createdAt && (
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#6b7280",
                            fontWeight: "500",
                          }}
                        >
                          {new Date(order.order_createdAt).toLocaleString()}
                        </div>
                      )}
                    </div>
                    {/* Status badge */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      {order.order_progressstatus && (
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            padding: "6px 12px",
                            borderRadius: "20px",
                            minWidth: "120px",
                            justifyContent: "center",
                            backgroundColor:
                              order.order_progressstatus === ""
                                ? "#fef2f2"
                                : order.order_progressstatus === "Kitchen"
                                  ? "#fffbeb"
                                  : order.order_progressstatus === "Receive"
                                    ? "#f0fdf4"
                                    : "#f8fafc",
                            border: `2px solid ${order.order_progressstatus === ""
                              ? "#fecaca"
                              : order.order_progressstatus === "Kitchen"
                                ? "#fed7aa"
                                : order.order_progressstatus === "Receive"
                                  ? "#bbf7d0"
                                  : "#e2e8f0"
                              }`,
                            color:
                              order.order_progressstatus === ""
                                ? "#dc2626"
                                : order.order_progressstatus === "Kitchen"
                                  ? "#d97706"
                                  : order.order_progressstatus === "Receive"
                                    ? "#059669"
                                    : "#6b7280",
                            fontWeight: "700",
                            fontSize: "11px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          <span
                            style={{
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor:
                                order.order_progressstatus === ""
                                  ? "#ef4444"
                                  : order.order_progressstatus === "Kitchen"
                                    ? "#f59e0b"
                                    : order.order_progressstatus === "Receive"
                                      ? "#10b981"
                                      : "#9ca3af",
                              marginRight: "8px",
                              boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.1)",
                            }}
                          />
                          {order.order_progressstatus === ""
                            ? "Pending"
                            : order.order_progressstatus === "Kitchen"
                              ? "In Kitchen"
                              : order.order_progressstatus === "Receive"
                                ? "Delivered"
                                : "Unknown"}
                        </span>
                      )}
                    </div>
                  </div>
                }
              >
                <Table
                  bordered
                  pagination={false}
                  className="order-table"
                  columns={[
                    {
                      title: "No",
                      key: "index",
                      render: (text, record, recordIndex) => (
                        <span>{recordIndex + 1}</span>
                      ),
                    },
                    {
                      title: "Food Name",
                      dataIndex: "product",
                      render: (product) => product.name,
                    },
                    {
                      title: "Price (" + symbol + ")",
                      dataIndex: "product",
                      render: (product) =>
                        `${symbol} ${parseFloat(product.price).toFixed(2)}`,
                    },
                    {
                      title: "Qty",
                      dataIndex: "quantity",
                      width: 80,
                      align: "center",
                      render: (quantity) => (
                        <span
                          style={{
                            fontWeight: "700",
                            color: "#ffffff",
                            backgroundColor: "#3b82f6",
                            padding: "4px 8px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            minWidth: "24px",
                            display: "inline-block",
                            textAlign: "center",
                          }}
                        >
                          {quantity}
                        </span>
                      ),
                    },
                    {
                      title: "Sub Menu",
                      dataIndex: "product",
                      render: (product) => {
                        if (!product.addOns || product.addOns.length === 0) {
                          return null;
                        }

                        const groupedSubMenu = product.addOns.reduce(
                          (acc, item) => {
                            if (!acc[item.group]) {
                              acc[item.group] = [];
                            }
                            acc[item.group].push(item);
                            return acc;
                          },
                          {}
                        );

                        return (
                          <ul>
                            {Object.entries(groupedSubMenu).map(
                              ([group, items]) => (
                                <li key={group}>
                                  <strong>{group}</strong>
                                  <ul>
                                    {items.map((item, index) => (
                                      <li key={index}>
                                        {item.name} : {symbol}{" "}
                                        {parseFloat(item.price).toFixed(2)}
                                      </li>
                                    ))}
                                  </ul>
                                </li>
                              )
                            )}
                          </ul>
                        );
                      },
                    },
                    {
                      title: "Total Price(" + symbol + ")",
                      dataIndex: "product",
                      render: (product, record) => {
                        const productTotal = product.price * record.quantity;
                        const addOnsTotal = product.addOns
                          ? product.addOns.reduce(
                            (sum, item) =>
                              sum + parseFloat(item.price) * record.quantity,
                            0
                          )
                          : 0;
                        const totalPrice = productTotal + addOnsTotal;
                        return (
                          <span>
                            {symbol} {totalPrice.toFixed(2)}
                          </span>
                        );
                      },
                    },
                  ]}
                  dataSource={order.order_items || []}
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "1rem",
                    fontSize: "1.2em",
                  }}
                >
                  {table.is_take_away_table === false && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <label htmlFor="pax">Pax:</label>
                      <Input
                        id="pax"
                        type="number"
                        min={1}
                        value={pax}
                        onChange={handlePaxChange}
                        style={{ width: "5rem", margin: "0" }}
                      />

                      {servicesWithTotals
                        .filter((s) => s.for_take_away === false)
                        .map((s) => (
                          <div
                            key={s._id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <label htmlFor={s._id}>{s.name}:</label>
                            <Input
                              min={0}
                              id={s._id}
                              type="number"
                              value={serviceQuantity[s._id] ?? 0}
                              onChange={(e) => {
                                const newQuantity = Number(e.target.value);
                                setServiceQuantity((prevQuantity) => ({
                                  ...prevQuantity,
                                  [s._id]: newQuantity,
                                }));
                              }}
                              style={{ width: "5rem", margin: "0" }}
                            />
                          </div>
                        ))}
                    </div>
                  )}

                  {table.is_take_away_table === true &&
                    servicesWithTotals
                      .filter((s) => s.for_take_away === true)
                      .map((s) => (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                        >
                          <label htmlFor={s._id}>{s.name}:</label>
                          <Input
                            min={0}
                            id={s._id}
                            type="number"
                            value={serviceQuantity[s._id] ?? 0}
                            onChange={(e) => {
                              const newQuantity = Number(e.target.value);
                              setServiceQuantity((prevQuantity) => ({
                                ...prevQuantity,
                                [s._id]: newQuantity,
                              }));
                            }}
                            style={{
                              width: "5rem",
                              margin: "0",
                              marginRight: "1rem",
                            }}
                          />
                        </div>
                      ))}

                  <div
                    style={{
                      marginLeft: "auto",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Total Price:&nbsp;
                    <span style={{ fontWeight: "bold", fontSize: "1.3em" }}>
                      {symbol} {getTotalWithoutTaxes()}
                    </span>
                  </div>
                </div>
              </Panel>
            ))}
        </Collapse>

        <br></br>

        <Collapse activeKey={activeKeys} onChange={handlePanelChange}>
          {orders
            .filter(
              (order) =>
                order.void_items &&
                order.void_items.length > 0 &&
                order.order_voidstatus == false
            )
            .map((order) => {
              return (
                <Panel
                  className="panelDesign"
                  style={{ backgroundColor: "#b9b9b9" }}
                  header={
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <strong>Order ID: #{order.oid}</strong>
                      <div className="badgeStyle">
                        <span
                          style={{
                            backgroundColor: "#FFEAEB",
                            color: "#ff1a1a",
                            borderRadius: "8px",
                            fontWeight: 700,
                            fontSize: "11px",
                            padding: "4px 14px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          Voided
                        </span>
                      </div>
                    </div>
                  }
                  key={order.oid}
                >
                  <Table
                    bordered
                    pagination={false}
                    className="order-table"
                    columns={[
                      {
                        title: "No",
                        key: "index",
                        render: (text, record, recordIndex) => (
                          <span>{recordIndex + 1}</span>
                        ),
                      },
                      {
                        title: "Food Name",
                        dataIndex: "product",
                        render: (product) => product.name,
                      },
                      {
                        title: "Price (" + symbol + ")",
                        dataIndex: "product",
                        render: (product) =>
                          `${symbol} ${parseFloat(product.price).toFixed(2)}`,
                      },
                      {
                        title: "Qty",
                        dataIndex: "quantity",
                        width: 80,
                        align: "center",
                        render: (quantity) => (
                          <span
                            style={{
                              fontWeight: "700",
                              color: "#ffffff",
                              backgroundColor: "#3b82f6",
                              padding: "4px 8px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              minWidth: "24px",
                              display: "inline-block",
                              textAlign: "center",
                            }}
                          >
                            {quantity}
                          </span>
                        ),
                      },
                      {
                        title: "Sub Menu",
                        dataIndex: "product",
                        render: (product) => {
                          if (!product.addOns || product.addOns.length === 0) {
                            return null;
                          }

                          const groupedSubMenu = product.addOns.reduce(
                            (acc, item) => {
                              if (!acc[item.group]) {
                                acc[item.group] = [];
                              }
                              acc[item.group].push(item);
                              return acc;
                            },
                            {}
                          );

                          return (
                            <ul>
                              {Object.entries(groupedSubMenu).map(
                                ([group, items]) => (
                                  <li key={group}>
                                    <strong>{group}</strong>
                                    <ul>
                                      {items.map((item, index) => (
                                        <li key={index}>
                                          {item.name} : {symbol}{" "}
                                          {parseFloat(item.price).toFixed(2)}
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                )
                              )}
                            </ul>
                          );
                        },
                      },

                      {
                        title: "Remark",
                        dataIndex: "remarks",
                        render: (remarks) => remarks,
                      },
                    ]}
                    dataSource={order.void_items || []}
                  />
                </Panel>
              );
            })}
        </Collapse>
        <>
          <style>{`
                    .totals-section {
                        margin-top: 50px;
                        margin-right: 20px;
                        font-size: 1.0em;
                        text-align: right;
                    }
                    `}</style>

          {/* Display totals */}
          {/* <div className="totals-section">
            <p>
              Total:
              <strong style={{ fontSize: "1.5em" }}>
                {" "}
                {symbol} {getTotalWithoutTaxes()}
              </strong>
            </p>

            <p>
              Tax:
              <strong style={{ fontSize: "1.5em" }}>
                {" "}
                {symbol} {getTotalTaxes()}
              </strong>
            </p>

            <p>
              Rounding:
              <strong style={{ fontSize: "1.5em" }}>
                {rounding < 0
                  ? ` -${symbol} ${Math.abs(rounding)}`
                  : `  ${symbol} ${rounding}`}
              </strong>
            </p>

            <p style={{ fontSize: "1.2em" }}>
              Grand Total:
              <strong style={{ fontSize: "1.8em" }}>
                {" "}
                {symbol} {grandTotal.toFixed(2)}
              </strong>
            </p>
          </div> */}
        </>
      </Modal>

      <Modal
        // title="Receipt"
        title={
          <div>
            Receipt
            <CloseButton
              className="close-button"
              onClick={() => {
                setTimeout(() => {
                  setShowReceiptModal(false);
                  // window.location.reload();
                  navigate("/");
                }, 500);
              }}
            />
          </div>
        }
        open={showReceiptModal}
        onCancel={() => {
          setTimeout(() => {
            setShowReceiptModal(false);
            // window.location.reload();
            navigate("/");
          }, 500);
        }}
        onOk={() => {
          // window.print();
          setTimeout(() => {
            receiptRef.current?.printReceipt();
            // setShowReceiptModal(false);
            // window.location.reload();
            // navigate("/");
          }, 500);
        }}
        className="print-modal"
        maskClosable={false}
        okText="Print"
      >
        <Receipt
          ref={receiptRef}
          invoiceId={orderInvoiceId}
          // orders={invoiceData}
          tableNumber={tableNumber}
          pax={pax}
          services={servicesWithTotals}
          takeAwayTable={takeAwayTable}
        />
      </Modal>

      {/* <Modal
        // title="Preview Receipt"
        title={
          <div>
            Preview Receipt
            <CloseButton
              className="close-button"
              onClick={() => setShowPreviewReceiptModal(false)}
            />
          </div>
        }
        open={showPreviewReceiptModal}
        onCancel={() => setShowPreviewReceiptModal(false)}
        onOk={() => {
          // window.print();

          setTimeout(() => {
            setShowPreviewReceiptModal(false);
          }, 500);
        }}
        className="print-modal"
      >
        <PreviewReceipt />
      </Modal> */}

      <AccessKeyModal ref={accessKeyModalRef} />

      <Modal
        // title="Payment"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {/* Payment on the left */}
            <span
              style={{
                fontWeight: 500,
                fontSize: "20px",
                color: "#1f2937",
                flex: 1,
                textAlign: "left",
                paddingLeft: "8px",
              }}
            >
              Payment
            </span>
            {/* Centered Table info */}
            <span
              style={{
                fontWeight: 800,
                color: "#1f2937",
                fontSize: "20px",
                lineHeight: "1.1",
                textAlign: "center",
                flex: 2,
              }}
            >
              Table {tableNumber} ({pax} Pax)
            </span>
            {/* Close button on the right */}
            <span
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                paddingRight: "8px",
              }}
            >
              <CloseButton onClick={handleClosePaymentModal} />
            </span>
          </div>
        }
        open={showPaymentModal}
        onCancel={handleClosePaymentModal}
        footer={null}
        destroyOnClose
        maskClosable={false}
        width={750}
        height={1000}
        style={{}}
        wrapClassName="custom-payment-modal"
      >
        <PaymentPage
          settings={settings}
          tableNumber={tableNumber}
          takeAwayTable={takeAwayTable}
          totalWithoutTaxes={getTotalWithoutTaxes()}
          totalCanDiscount={getTotalCanDiscount()}
          tableId={table._id}
          deposit={deposit}
          depositMethod={depositMethod}
          hasDeposit={hasDeposit}
          orders={safeTableOrders.filter((order) => {
            if (!selectedOrders.includes(order.oid)) return false;
            if (settings.deliverDisableToggle === true) {
              return (
                order.order_progressstatus === "Receive" ||
                order.order_progressstatus === "Kitchen"
              );
            } else {
              return order.order_progressstatus === "Receive";
            }
          })}
          deliverDisableToggle={settings.deliverDisableToggle}
          onPaymentValidation={handlePaymentValidation}
          showPaymentModal={showPaymentModal}
          orderID={orders[0]?._id}
          pax={pax}
          services={servicesWithTotals}
          selectedOrders={selectedOrders}
          taxesData={taxes}
        />
      </Modal>
    </div>
  );
};

export default BillList;
